import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import type { MultipleContactPersonValue } from "../../types";
import { MultipleContactPersonInputBase } from "../../shared/MultipleContactPersonInputBase";

export const MultipleContactPersonInput: FC<InputProps<MultipleContactPersonValue>> = props => {
  return <MultipleContactPersonInputBase {...props} isMultistepFormVersion={true} />;
};
